export default "Using computational fluid dynamics and automation to optimize aerodynamics.";